import {Endpoints} from '../../endpoints';
import ZipCitySuggestion from "./zip-city-suggestion_class";
import {ZipAndCityInterface} from "./zip-and-city_interface";
class ZipAndCity {

    /**
     * @param localStorage
     * @param helper
     */
    constructor(
        localStorage,
        helper,
    ) {
        this.helper = helper;
        this.localStorage = localStorage;
        this.shippingAddress = false;

        this.initCheckoutForm()
    }

    /**
     * @returns {boolean}
     */
    isGermanContext() {
        const htmlElement = document.querySelector('html');
        const lang = htmlElement.getAttribute("lang").toLowerCase();

        if (lang === null) {

            return false;
        }

        return lang === 'de';
    }

    /**
     * Method to handle zip and city completion
     * @returns {void}
     */
    initCheckoutForm() {

        const zipElement = this.getCheckoutFormZipElement();
        const cityElement = this.getCheckoutFormCityElement();
        const shippingZipElement = this.getCheckoutFormShippingZipElement();
        const shippingCityElement = this.getCheckoutFormShippingCityElement();

        if (zipElement === null || cityElement === null) {

            return;
        }

        this.setEventsToZip(zipElement);
        this.setEventsToCity(cityElement);

        if (shippingZipElement === null && shippingCityElement === null) {

            return;
        }

        this.setEventsToZip(shippingZipElement);
        this.setEventsToCity(shippingCityElement);

        this.setKeydownEventOnDocumentForSuggestionContainer();
    }

    /**
     * @returns {HTMLElement}
     */
    getCheckoutFormZipElement() {

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressZip);
    }

    /**
     * @returns {HTMLElement}
     */
    getCheckoutFormCityElement() {

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressCity);
    }

    /**
     * @returns {HTMLElement}
     */
    getCheckoutFormCountryElement() {

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressCountry)
    }

    /**
     * @param zipElement
     * @returns {void}
     */
    setEventsToZip(zipElement) {

        /*zipElement.addEventListener(
            'change',
            () => this.onZipChange(
                zipElement,
                'change'
            )
        );*/

        zipElement.addEventListener(
            'input',
            () => this.onZipChange(
                zipElement,
                'input'
            )
        );
    }

    /**
     * @param cityElement
     * @returns {void}
     */
    setEventsToCity(cityElement) {

        /*cityElement.addEventListener(
            'change',
            () => this.onCityChange(
                cityElement,
                'change'
            )
        )*/

        cityElement.addEventListener(
            'input',
            () => this.onCityChange(
                cityElement,
                'input'
            )
        )
    }

    /**
     * @param zipElement
     * @param eventType
     * @returns {void}
     */
    onZipChange(
        zipElement,
        eventType
    ) {
        const zipCode = zipElement.value
        const zipId = zipElement.id

        if (eventType === 'input' &&
            zipCode.length < 2
        ) {
            return;
        }

        // Set switch
        this.checkIfShippingAddressZip(zipId)

        this.sendRequest(
            Endpoints.EndPointLocationCity,
            'GET',
            this.handleCityResponse,
            {
                [ZipAndCityInterface.ParameterLocationCity]: zipCode,
                [ZipAndCityInterface.ParameterLocationCountry]: this.getSelectedCountry()
            }
        )
    }

    /**
     * @param cityElement
     * @param eventType
     * @returns {void}
     */
    onCityChange(
        cityElement,
        eventType
    ) {
        const cityName = cityElement.value;
        const cityId = cityElement.id;

        if (eventType === 'input' &&
            cityName.length < 2
        ) {
            return;
        }

        this.checkIfShippingAddressCity(cityId);

        this.sendRequest(
            Endpoints.EndPointLocationPostalCode,
            'GET',
            this.handleZipResponse,
            {
                [ZipAndCityInterface.ParameterLocationPostalCode]: cityName,
                [ZipAndCityInterface.ParameterLocationCountry]: this.getSelectedCountry()
            }
        )
    }

    /**
     * @param endpoint
     * @param requestType
     * @param callback
     * @param parameters
     * @returns {void}
     */
    sendRequest(
        endpoint,
        requestType = 'GET',
        callback,
        parameters = {}
    ) {

        if (!this.isEmptyObject(parameters)) {

            endpoint = this.addParameters(
                parameters,
                endpoint
            );
        }

        if (requestType !== 'GET') {

            return;
        }
        let xhr = new XMLHttpRequest()

        xhr.open(
            requestType,
            endpoint,
            true
        )

        xhr.onload = function () {
            let error = null
            let data = null

            if (xhr.status >= 200 && xhr.status < 300) {

                data = xhr.responseText

                callback(
                    error,
                    data,
                    this
                )

            } else {

                error = xhr.status

                callback(
                    error,
                    data,
                    this
                )

            }
        }.bind(this)

        xhr.onerror = function () {

            console.log('Request failed')
        }

        xhr.send();
    }

    /**
     * @param object
     * @returns {boolean}
     */
    isEmptyObject(object) {
        if (!object) {

            return true;
        }

        if (object === null) {

            return true;
        }

        if (object === undefined) {

            return true;
        }

        return Object.keys(object).length <= 0;
    }

    /**
     * @param error
     * @param data
     * @param me
     * @returns {void}
     */
    handleCityResponse(
        error,
        data,
        me
    ) {

        if (error) {
            console.log(error);
        }

        if (!data || data === undefined) {

            console.log('no data')

            return;
        }

        const responseData = JSON.parse(data);

        if (!responseData.hasOwnProperty(ZipAndCityInterface.KeyToCitySuggestions)) {

            return;
        }

        me.handleCitySuggestions(
            responseData[ZipAndCityInterface.KeyToCitySuggestions]
        );
    }

    /**
     * @param error
     * @param data
     * @param me
     * @returns {void}
     */
    handleZipResponse(
        error,
        data,
        me
    ) {

        if (error) {
            console.log(error);
        }

        if (!data) {

            console.log('no data')

            return;
        }

        const responseData = JSON.parse(data);

        if (!responseData.hasOwnProperty(ZipAndCityInterface.KeyToZipSuggestions)) {

            return;
        }

        me.handleZipSuggestions(
            responseData[ZipAndCityInterface.KeyToZipSuggestions]
        );
    }

    /**
     * @param parameters
     * @param endpoint
     * @returns {*|string}
     */
    addParameters(
        parameters,
        endpoint
    ) {
        let endpointWithParameters = '';

        if (this.isEmptyObject(parameters)) {

            return endpoint;
        }

        let params = Object.keys(parameters)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k]))
            .join('&');

        if (params === '') {

            return endpoint;
        }

        endpointWithParameters = endpoint + '?' + params

        return endpointWithParameters;
    }

    /**
     * @param responseData
     * @returns {void}
     */
    handleCitySuggestions(responseData) {

        const suggestionContainer = this.getCitySuggestionContainer();

        if (suggestionContainer === null) {

            return;
        }

        this.clearSuggestionContainer(suggestionContainer);
        this.buildHTMLForSuggestions(
            responseData,
            suggestionContainer
        );
        this.buildSuggestionItemsFromSelection(this.getCitySuggestionContainer());
    }

    /**
     * @param responseData
     * @returns {void}
     */
    handleZipSuggestions(responseData) {

        const suggestionContainer = this.getZipSuggestionContainer();

        if (suggestionContainer === null) {

            return;
        }

        this.clearSuggestionContainer(suggestionContainer);
        this.buildHTMLForSuggestions(
            responseData,
            suggestionContainer
        );
        this.buildSuggestionItemsFromSelection(this.getZipSuggestionContainer());
    }

    /**
     * @returns {HTMLElement}
     */
    getCitySuggestionContainer() {

        if (this.shippingAddress === true) {

            return document.getElementById(ZipAndCityInterface.SelectorShippingAddressCitySuggestionContainer)
        }

        return document.getElementById(ZipAndCityInterface.SelectorAddressCitySuggestionContainer)
    }

    /**
     * @returns {HTMLElement}
     */
    getZipSuggestionContainer() {

        if (this.shippingAddress === true) {

            return document.getElementById(ZipAndCityInterface.SelectorShippingAddressZipSuggestionContainer)
        }

        return document.getElementById(ZipAndCityInterface.SelectorAddressZipSuggestionContainer)
    }

    /**
     * @param htmlElement
     * @returns {void}
     */
    clearSuggestionContainer(htmlElement) {

        htmlElement.innerHTML = '';
    }

    /**
     * @param responseData
     * @param suggestionContainer
     * @returns {void}
     */
    buildHTMLForSuggestions(
        responseData,
        suggestionContainer
    ) {

        Object.keys(responseData).forEach(
            key => {

                let div = this.buildSuggestionItemForIteration(
                    key,
                    responseData[key]
                );

                suggestionContainer.appendChild(div);
            }
        )

        this.toggleSuggestionContainer(
            suggestionContainer,
            true
        );
    }

    /**
     * @param key
     * @param value
     * @returns {HTMLDivElement}
     */
    buildSuggestionItemForIteration(
        key,
        value,
    ) {
        let div = document.createElement('div');

        // Set stuff to divs
        div.textContent = `${key} | ${value}`;
        div.id = `suggestion-${key}`;
        div.classList.add(ZipAndCityInterface.SelectorCitySuggestionClass);
        div.setAttribute(
            ZipAndCityInterface.DataAttributeZip,
            key
        );
        div.setAttribute(
            ZipAndCityInterface.DataAttributeCity,
            value
        );

        return div;
    }

    /**
     * @param citySuggestionContainer
     * @returns {void}
     */
    buildSuggestionItemsFromSelection(citySuggestionContainer) {

        const elements = citySuggestionContainer.getElementsByClassName(
            ZipAndCityInterface.SelectorCitySuggestionClass
        );

        if (elements.length <= 0) {

            //TODO: Inform user ... nothing found

            return;
        }

        // iterate given elements and provide them with events
        for (let i = 0; i < elements.length; i++) {

            new ZipCitySuggestion(
                elements[i],
                this.shippingAddress
            )
        }
    }

    /**
     * @param suggestionContainer
     * @param forceShow
     * @returns {void}
     */
    toggleSuggestionContainer(
        suggestionContainer,
        forceShow = false
    ) {

        if (forceShow === true) {

            suggestionContainer.style.display = 'block';

            return;
        }

        if (suggestionContainer.style.display === 'none' || suggestionContainer.style.display === '') {

            suggestionContainer.style.display = 'block';

            return;
        }

        suggestionContainer.style.display = 'none';
    }

    /**
     * @returns {HTMLElement|null}
     */
    getCheckoutFormShippingZipElement() {

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressShippingZip);
    }

    /**
     * @returns {HTMLElement|null}
     */
    getCheckoutFormShippingCityElement() {

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressShippingCity);
    }

    /**
     * @param zipId
     * @returns {void}
     */
    checkIfShippingAddressZip(zipId) {

        if (zipId === ZipAndCityInterface.SelectorCheckoutAddressShippingZip) {

            this.shippingAddress = true;

            return;
        }

        this.shippingAddress = false;
    }

    /**
     *
     * @param cityId
     * @returns {void}
     */
    checkIfShippingAddressCity(cityId) {

        if (cityId === ZipAndCityInterface.SelectorCheckoutAddressShippingCity) {

            this.shippingAddress = true;

            return;
        }

        this.shippingAddress = false;
    }

    /**
     * @returns {*|string}
     */
    getSelectedCountry() {
        const countryElement = this.getCheckoutFormCountryElement();

        if (countryElement === null) {

            return ZipAndCityInterface.DefaultCountry;
        }

        return countryElement.value ?? ZipAndCityInterface.DefaultCountry;
    }

    /**
     * @returns {void}
     */
    setKeydownEventOnDocumentForSuggestionContainer() {
        document.addEventListener(
            'keydown',
            function (event) {

                if (event.key === 'Escape' || event.keyCode === 27) {

                    const suggestionContainer1 = document.getElementById(ZipAndCityInterface.SelectorShippingAddressCitySuggestionContainer)
                    const suggestionContainer2 = document.getElementById(ZipAndCityInterface.SelectorShippingAddressZipSuggestionContainer)
                    const suggestionContainer3 = document.getElementById(ZipAndCityInterface.SelectorAddressCitySuggestionContainer)
                    const suggestionContainer4 = document.getElementById(ZipAndCityInterface.SelectorAddressZipSuggestionContainer)

                    if (suggestionContainer1) {
                        suggestionContainer1.style.display = 'none';
                    }

                    if (suggestionContainer2) {
                        suggestionContainer2.style.display = 'none';
                    }

                    if (suggestionContainer3) {
                        suggestionContainer3.style.display = 'none';
                    }

                    if (suggestionContainer4) {
                        suggestionContainer4.style.display = 'none';
                    }

                }
            }
        )
    }
}

export default ZipAndCity;